import CCTVSecurityOffers from "./CCTVSecurityOffers";

const CCTVSecurity = () => {
  return (
    <section className="solution-item-page">
      <CCTVSecurityOffers />
    </section>
  );
}; 

export default CCTVSecurity; 
